import { cn } from "@/lib/utils";

interface MessageBubbleProps {
  content: string;
  isOwn?: boolean;
  timestamp: Date;
  status?: "sent" | "delivered" | "read";
}

export function MessageBubble({
  content,
  isOwn = false,
  timestamp,
  status = "delivered",
}: MessageBubbleProps) {
  const formatTime = (date: Date) => {
    return date.toLocaleTimeString("en-AU", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className={cn("flex", isOwn ? "justify-end" : "justify-start")}>
      <div
        className={cn(
          "max-w-[75%] rounded-2xl px-4 py-3",
          "shadow-sm",
          isOwn
            ? "bg-primary text-primary-foreground rounded-br-md"
            : "bg-muted text-foreground rounded-bl-md"
        )}
      >
        <p className="text-sm leading-relaxed">{content}</p>
        <div className="flex items-center justify-end gap-1 mt-1">
          <span className="text-xs opacity-70">{formatTime(timestamp)}</span>
          {isOwn && (
            <span className="text-xs opacity-70">
              {status === "read" ? "✓✓" : "✓"}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}